<script setup>
const vacanciesStore = useVacanciesStore();
const route = useRoute();

const requests = [
  useAsyncData(() => vacanciesStore.fetchVacancy(route.params.vacancySlug)),
];

if (!vacanciesStore.groups) {
  requests.push(vacanciesStore.fetchGroups());
}

const [{ data: vacancyData, error: vacancyError }] =
  await Promise.all(requests);

if (vacancyError.value) {
  const { statusCode, statusMessage } = vacancyError.value;
  throw createError({ statusCode, statusMessage, fatal: true });
}

const groupData = computed(() =>
  vacanciesStore.getGroupById(vacancyData.value.groupId),
);
</script>

<template>
  <div class="pages-vacancies-vacancy-slug">
    <BundlesHead
      :title="$t('vacancies.singleVacancy.title')"
      :subtitle="vacancyData.name"
      :caption="groupData.name"
      :back-text="$t('vacancies.singleVacancy.back')"
      back-url="/vacancies"
    />

    <template v-if="vacancyData.description">
      <CtrSidebar
        v-for="(description, descriptionIndex) in vacancyData.description"
        :key="descriptionIndex"
        class="pages-vacancies-vacancy-slug__sidebar"
        :title="description.title"
        :top-line="descriptionIndex > 0"
      >
        <template #content>
          <CtrText in-sidebar :text="description.text" />
        </template>
      </CtrSidebar>
    </template>

    <BundlesFoot
      :back-text="$t('vacancies.singleVacancy.back')"
      back-url="/vacancies"
    >
      <template #column-1>
        <ButtonsUnderlined
          :title="$t('vacancies.singleVacancy.applyToVacancy')"
          :url="`/vacancies/${vacancyData.id}/form`"
          target="_self"
        />
      </template>
    </BundlesFoot>
  </div>
</template>

<style scoped lang="scss">
.pages-vacancies-vacancy-slug {
  padding-top: em($gap-page-title);
  padding-bottom: em(150);

  @include media-breakpoint-down(sm) {
    padding-top: em($gap-page-title-sm);
    padding-bottom: em(65);
  }

  &__sidebar {
    margin-bottom: em(102);

    @include media-breakpoint-down(sm) {
      margin-bottom: em(65);
    }
  }
}
</style>
